export const sameRegistration = (a, b) => {
    const left = a || {};
    const right = b || {};
    const keys = new Set([...Object.keys(left), ...Object.keys(right)]);
    for (const key of keys) {
        const leftValue = left[key];
        const rightValue = right[key];
        if (Object.is(leftValue, rightValue)) {
            continue;
        }
        if (leftValue === undefined || rightValue === undefined) {
            return false;
        }
        if (typeof leftValue === 'object' &&
            typeof rightValue === 'object' &&
            JSON.stringify(leftValue) === JSON.stringify(rightValue)) {
            continue;
        }
        return false;
    }
    return true;
};
